import $ from 'jquery';
import ko from 'knockout';

ko.bindingHandlers.writeOnlyValue = {
    init: function(element, valueAccessor) {
        $(element).on('change', function() {
            var value = valueAccessor(),
                // eslint-disable-next-line no-invalid-this
                accountName = $('option', this)
                    .filter(':selected')
                    .val();

            value(accountName);
        });
    },
    update: function(element, valueAccessor) {
        var value = valueAccessor();
        $(element).val(value());
    }
};

